"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getCustomerIdentifier = function getCustomerIdentifier() {
  if (localStorage.getItem("mco-shop-connection")) {
    var connection = JSON.parse(localStorage.getItem("mco-shop-connection"));
    return connection === null || connection === void 0 ? void 0 : connection.identifier;
  }
  return;
};
var _default = getCustomerIdentifier;
exports.default = _default;